import { useMemo } from 'react';
import { PP_EMPTY_STATES_TYPES } from './useEmptyStateType';
import {
  FiltersDudeIllustration,
  OopsIllustration
} from '@linearb/linui-common';
import MissingFiltersActions from '../../../state/filters/components/empty-states/MissingFiltersActions';
import { ProjectProgressionFiltersContext } from '../../../state/filters/contexts';

const emptyStateViews = {
  [PP_EMPTY_STATES_TYPES.MISSING_FILTERS]: {
    Illustration: FiltersDudeIllustration,
    Title: <>Missing Filters</>,
    Description: (
      <>Apply a new filter or load an existing filter set to view progress.</>
    ),
    Actions: (
      <MissingFiltersActions Context={ProjectProgressionFiltersContext} />
    )
  },
  DEFAULT: {
    Illustration: () => <OopsIllustration width='20rem' />,
    Title: <>Cannot present Progress Over Time</>,
    Description: (
      <>
        An error had occurred and we couldn't provide you with the requested
        progress over time <br />
        Please try again in a few minutes or contact support for assistance.
      </>
    )
  }
};

const useEmptyStateConfig = ({ type }) => {
  const {
    Illustration = null,
    Title = null,
    Description = null,
    Actions = null
  } = useMemo(() => emptyStateViews[type] || emptyStateViews.DEFAULT);

  return {
    Illustration,
    Title,
    Description,
    Actions
  };
};

export default useEmptyStateConfig;
